import SessionService from "@/services/session.service";
import Notify from 'quasar/src/plugins/Notify.js';;
import i18n from "@/lang";
import api from "@/api/api";

const validateDashboardEventsSingle = async (to, from, next) => {
  const eventId = to.params.eventId;

  if (!eventId) {
    Notify.create({
      type: "negative",
      message: i18n.global.t("error.invalidEvent"),
      position: "bottom",
    });

    return next({ name: "dashboardEventsList" });
  }

  try {
    const eventData = await api.verifyDashboardAccessByEventId(eventId);

    if (
      !eventData ||
      !eventData.data ||
      eventData.data.data.hasAccess !== eventId ||
      eventData.data.message !== "success"
    ) {
      Notify.create({
        type: "negative",
        message: i18n.global.t("error.invalidEvent"),
        position: "bottom",
      });
      return next({
        name: "dashboardEventsList",
        query: { invalidEvent: "true" },
      });
    }

    if (!validateEventStatus(eventData, next)) {
      return;
    }

    next();
  } catch (error) {
    Notify.create({
      type: "negative",
      message: i18n.global.t("error.fetchEvents"),
      position: "bottom",
    });
    next({ name: "dashboardEventsList", query: { fetchError: "true" } });
  }
};

const validateEventStatus = (eventData, next) => {
  if (!eventData.eventStatus) {
    return true;
  }

  if (eventData.eventStatus === "unverified") {
    Notify.create({
      type: "negative",
      message: i18n.global.t("error.eventUnverified"),
      position: "bottom",
    });
    return next({
      name: "dashboardEventsList",
      query: { invalidEvent: "true" },
    });
  }

  if (eventData.eventStatus === "verified") {
    return true;
  }
};

const validatePasswordReset = (to, from, next) => {
  const { key, email } = to.query;

  if (key && email) {
    SessionService.handleResetQuery(key, email);
    return next();
  }

  if (!SessionService.hasResetParams()) {
    return next("/login");
  }

  next();
};

const PUBLIC_TABS = ["settings", "images", "integration", "profile"];
const TAB_PERMISSIONS = {
  "photographers-list": ["organizer", "administrator"],
  "bookings": ["organizer", "photographer"],
  "register-photographer": ["organizer"],
};
const validTabs = [...PUBLIC_TABS, ...Object.keys(TAB_PERMISSIONS)];

const redirectToProfile = (next) => next({ name: "userPanel", query: { tab: "profile" } });

const handleTabSwitch = (to, from, next) => {
  if (!to.query.tab || !validTabs.includes(to.query.tab)) {
    return redirectToProfile(next);
  }

  const restriction = TAB_PERMISSIONS[to.query.tab];
  if (restriction) {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!restriction.includes(user?.role)) {
      Notify.create({ type: "negative", message: i18n.global.t("error.route"), position: "bottom" });
      return redirectToProfile(next);
    }
  }

  next();
};

export default {
  validatePasswordReset,
  validateDashboardEventsSingle,
  handleTabSwitch,
};
